export const welcomeVideoData = [
    {
        title: 'Watch Product Tour',
        content: 'Get familiar with GroupApp by watching our quick overview video.',
    },
];
